var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import moment from 'moment';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { TAKEDOWN_STATUS, } from '../../interfaces/createApplication';
import { CUSTOMER_FIELD } from './config/create_application_schema';
import { buildCustomerLookupValues, toContactOptions, } from './customer_lookup_service';
import { asText, SUCCESS_STATUS_CODE } from './service_helpers';
var PROGRAM_ERROR_MESSAGE = 'Could not load the program list. Please try again.';
export var fetchTakedownPrograms = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, rows, optionsByValue_1, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4, api_service.get({
                        endPoint: api_urls.PROGRAMS_LIST,
                        showLoader: false,
                    })];
            case 1:
                response = _b.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, { options: [], errorMessage: PROGRAM_ERROR_MESSAGE }];
                }
                rows = Array.isArray(response.data.data) ? response.data.data : [];
                optionsByValue_1 = new Map();
                rows.forEach(function (program) {
                    var programAspireOId = asText(program === null || program === void 0 ? void 0 : program.ProgramAspireOId);
                    var label = asText(program === null || program === void 0 ? void 0 : program.Name);
                    if (!programAspireOId || !label || optionsByValue_1.has(programAspireOId)) {
                        return;
                    }
                    optionsByValue_1.set(programAspireOId, {
                        label: label,
                        value: programAspireOId,
                        programId: asText(program === null || program === void 0 ? void 0 : program.Id),
                    });
                });
                return [2, { options: Array.from(optionsByValue_1.values()), errorMessage: '' }];
            case 2:
                error_1 = _b.sent();
                return [2, { options: [], errorMessage: PROGRAM_ERROR_MESSAGE }];
            case 3: return [2];
        }
    });
}); };
var LOC_ERROR_MESSAGE = 'Could not fetch the line of credit details. Please try again.';
var toLocStatus = function (expirationDate) {
    if (!expirationDate) {
        return '';
    }
    var expiry = moment(expirationDate).utcOffset(0);
    if (!expiry.isValid()) {
        return '';
    }
    return moment().isBefore(expiry) ? TAKEDOWN_STATUS.Active : TAKEDOWN_STATUS.Expired;
};
var toLocApplication = function (row) {
    var _a, _b;
    return ({
        transactionNum: asText(row === null || row === void 0 ? void 0 : row.TransactionNum),
        applicationId: asText(row === null || row === void 0 ? void 0 : row.ApplicationId),
        customerName: asText(row === null || row === void 0 ? void 0 : row.Name) || asText(row === null || row === void 0 ? void 0 : row.CustomerName),
        approvedAmount: Number((_a = row === null || row === void 0 ? void 0 : row.ApprovedAmount) !== null && _a !== void 0 ? _a : 0),
        availableAmount: Number((_b = row === null || row === void 0 ? void 0 : row.AvailableAmount) !== null && _b !== void 0 ? _b : 0),
        expirationDate: asText(row === null || row === void 0 ? void 0 : row.ExpirationDate),
        status: toLocStatus(row === null || row === void 0 ? void 0 : row.ExpirationDate),
        isDraft: Boolean(row === null || row === void 0 ? void 0 : row.IsDraft),
        isRentalFleet: Boolean(row === null || row === void 0 ? void 0 : row.RentalFleet),
        takedowns: (Array.isArray(row === null || row === void 0 ? void 0 : row.TakeDowns) ? row.TakeDowns : [])
            .map(function (takedown) {
            var _a;
            return ({
                transactionNum: asText(takedown === null || takedown === void 0 ? void 0 : takedown.TransactionNum),
                amountRequested: Number((_a = takedown === null || takedown === void 0 ? void 0 : takedown.AmountRequested) !== null && _a !== void 0 ? _a : 0),
                createdDate: asText(takedown === null || takedown === void 0 ? void 0 : takedown.CreatedDate),
                status: asText(takedown === null || takedown === void 0 ? void 0 : takedown.Status),
            });
        })
            .sort(function (first, second) {
            return moment(second.createdDate).diff(moment(first.createdDate));
        }),
    });
};
export var fetchLocApplications = function (programAspireOId, customerTaxId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, rows, error_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4, api_service.get({
                        endPoint: api_urls.GET_LOC_APPLICATION_LIST,
                        payLoad: { SSN: customerTaxId, ProgramAspireOId: programAspireOId },
                        showLoader: false,
                    })];
            case 1:
                response = _c.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, {
                            locApplications: [],
                            errorMessage: asText((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) || LOC_ERROR_MESSAGE,
                        }];
                }
                rows = Array.isArray(response.data.data) ? response.data.data : [];
                return [2, { locApplications: rows.map(toLocApplication), errorMessage: '' }];
            case 2:
                error_2 = _c.sent();
                return [2, { locApplications: [], errorMessage: LOC_ERROR_MESSAGE }];
            case 3: return [2];
        }
    });
}); };
export var fetchLocAmountsInfo = function (locAspireOId, programAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, row, error_3;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!locAspireOId || !programAspireOId) {
                    return [2, null];
                }
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                return [4, api_service.get({
                        endPoint: api_urls.GET_LOC_AMOUNTS_INFO,
                        payLoad: { LOCAspireOId: locAspireOId, ProgramAspireOId: programAspireOId },
                        showLoader: false,
                    })];
            case 2:
                response = _e.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, null];
                }
                row = (_b = response.data.data) !== null && _b !== void 0 ? _b : {};
                return [2, {
                        transactionNum: asText(row.ContractAspireOId) || locAspireOId,
                        approvedAmount: Number((_c = row.ApprovedAmount) !== null && _c !== void 0 ? _c : 0),
                        availableAmount: Number((_d = row.AvailableAmount) !== null && _d !== void 0 ? _d : 0),
                        expirationDate: asText(row.ExpirationDate),
                        status: toLocStatus(row.ExpirationDate),
                        isRentalFleet: Boolean(row.RentalFleet),
                    }];
            case 3:
                error_3 = _e.sent();
                return [2, null];
            case 4: return [2];
        }
    });
}); };
export var fetchLocCustomerPrefill = function (txAspireOId, isConsumerProgram) {
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, application, customer, values, isBillingSameAsMain, entityTypeCode, error_4;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!txAspireOId) {
                        return [2, null];
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APPLICATION_DETAILS,
                            payLoad: { TxAspireOId: txAspireOId },
                            showLoader: false,
                        })];
                case 2:
                    response = _g.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                        return [2, null];
                    }
                    application = (_b = response.data.data) !== null && _b !== void 0 ? _b : {};
                    customer = application.CustomerInfo;
                    if (!customer) {
                        return [2, null];
                    }
                    values = buildCustomerLookupValues({
                        CustomerInfo: __assign(__assign({}, customer), { MainAddress: (_c = customer.MainAddress) !== null && _c !== void 0 ? _c : customer.Address, LegalRegisteredName: (_d = customer.LegalRegisteredName) !== null && _d !== void 0 ? _d : customer.LegalRegName, DateBusinessIncorporated: (_e = customer.DateBusinessIncorporated) !== null && _e !== void 0 ? _e : customer.BusinessIncorporatedDate }),
                    }, isConsumerProgram);
                    isBillingSameAsMain = customer.IsBillToLocSameAsCustLoc;
                    if (isBillingSameAsMain === 0 || isBillingSameAsMain === 1) {
                        values[CUSTOMER_FIELD.BillingSameAsMain] = isBillingSameAsMain === 1;
                    }
                    entityTypeCode = String((_f = values[CUSTOMER_FIELD.EntityType]) !== null && _f !== void 0 ? _f : '');
                    return [2, {
                            values: values,
                            contacts: toContactOptions(application.ContactInfo, entityTypeCode),
                        }];
                case 3:
                    error_4 = _g.sent();
                    return [2, null];
                case 4: return [2];
            }
        });
    });
};
